import { CanMatchFn, Route, UrlSegment } from '@angular/router';

const UUID_REGEX: RegExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Only match a route when every `:param` segment in its path is a valid UUID.
 *
 * Returning false lets the router skip the route and fall through to the '**'
 * wildcard, so paths with malformed ids (e.g. /auctions/watchlist or
 * /profiles/my-profile/view-invoice/abc) hit the 404 page instead of attempting
 * to load a resource with an invalid id.
 *
 * Apply via `canMatch: [uuidParamsMatchGuard]` on any route that has id params.
 */
export const uuidParamsMatchGuard: CanMatchFn = (
    route: Route,
    segments: UrlSegment[],
): boolean => {
    const tokens: string[] = (route.path ?? '').split('/');
    return tokens.every((token: string, index: number): boolean => {
        if (!token.startsWith(':')) {
            return true;
        }
        const value: string | undefined = segments[index]?.path;
        return !!value && UUID_REGEX.test(value);
    });
};
